import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { templateSelector } from 'redux/modules/template-wizard/selectors';
import { Dispatch } from 'redux/types';
import { openTemplateInEditorLocation } from 'utils/routes';
import LoadingStep from '../LoadingStep';
import { templateWizardError } from './actions';
import TemplateWizard from './TemplateWizard';
import TemplateWizardLandingPage from './TemplateWizardLandingPage';
import { LandingPageFlowType, TemplateWizardFlowType } from './types';
import useTemplateLoader from './useTemplateLoader';
import { block, getTemplateFlowType, shouldSeeLandingPage } from './utils';

const TemplateWizardRouter: React.FC = () => {
  const dispatch = useDispatch<Dispatch>();
  const history = useHistory();
  const [selectedFlowType, setSelectedFlowType] = useState<
    TemplateWizardFlowType
  >(undefined);
  const template = useSelector(templateSelector);

  const showLandingPage = shouldSeeLandingPage(template) && !selectedFlowType;
  const flowType = getTemplateFlowType(template);

  const effectiveFlowType = flowType ?? selectedFlowType;

  const { status: templateStatus } = useTemplateLoader({
    onError: err => dispatch(templateWizardError(err, true)),
  });

  const handleFlowSelect = useCallback(
    (flow: LandingPageFlowType) => {
      if (flow === 'audio' || flow === 'video') {
        setSelectedFlowType(flow);
      } else {
        history.push(
          openTemplateInEditorLocation(
            template.templateId,
            template.templateType,
          ),
        );
      }
    },
    [history, template?.templateId, template?.templateType],
  );

  const handleConfirmTemplateSelection = useCallback(() => {
    setSelectedFlowType(flowType);
  }, [flowType]);

  if (templateStatus !== 'success') {
    return <LoadingStep className={block('loading')} message="Loading" />;
  }

  if (showLandingPage) {
    return (
      <TemplateWizardLandingPage
        onFlowSelect={handleFlowSelect}
        onConfirmTemplateSelection={handleConfirmTemplateSelection}
      />
    );
  }

  return <TemplateWizard flowType={effectiveFlowType} />;
};

export default TemplateWizardRouter;
